import styled from '@emotion/styled';
import { Colors } from '@utex/ui-kit';

interface Props {
  highlight: boolean;
}

export const Part = styled('span')<Props>`
  color: ${(props) => (props.highlight ? Colors.ut.primary : Colors.text.default)};
`;
